import { render } from "./UserIndex.vue?vue&type=template&id=6b59e0c8"
import script from "./UserIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./UserIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/user/components/UserIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b59e0c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b59e0c8', __exports__)) {
    api.reload('6b59e0c8', __exports__)
  }
  
  module.hot.accept("./UserIndex.vue?vue&type=template&id=6b59e0c8", () => {
    api.rerender('6b59e0c8', render)
  })

}


export default __exports__